module.exports = __webpack_public_path__ + "static/media/bg_04.3f4f530a.jpg";